import defaultClient from '@src/api/clients/default';

export function fetchOptimizerRuns(params = {}) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/runs/',
    method: 'GET',
    options: { params },
  });
}

export function fetchOptimizerRunDetail(runId) {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/runs/${runId}/`,
    method: 'GET',
  });
}

export function approveOptimizerRun(runId, { override = false } = {}) {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/runs/${runId}/approve/`,
    method: 'POST',
    payload: override ? { override: true } : {},
  });
}

export function rejectOptimizerRun(runId, notes = '') {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/runs/${runId}/reject/`,
    method: 'POST',
    payload: { notes },
  });
}

export function fetchOptimizerRunChanges(runId) {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/runs/${runId}/changes/`,
    method: 'GET',
  });
}

export function fetchOptimizerConfigs(params = {}) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/configs/',
    method: 'GET',
    options: { params },
  });
}

export function createOptimizerConfig(data) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/configs/',
    method: 'POST',
    payload: data,
  });
}

export function updateOptimizerConfig(configId, data) {
  return defaultClient.request({
    url: `dashboard/facebook/budget-optimizer/configs/${configId}/`,
    method: 'PATCH',
    payload: data,
  });
}

export function fetchOptimizerServedDmas(clientId) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/configs/served-dmas/',
    method: 'GET',
    options: { params: { client_id: clientId } },
  });
}

export function fetchOptimizerGlobalConfig() {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/configs/global/',
    method: 'GET',
  });
}

export function updateOptimizerGlobalConfig(data) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/configs/global/',
    method: 'PATCH',
    payload: data,
  });
}

export function triggerOptimizerRun(clientId, dryRun = true) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/trigger/',
    method: 'POST',
    payload: { client_id: clientId, dry_run: dryRun },
  });
}

export function fetchOptimizerComTrend(clientId, days = 60) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/runs/com-trend/',
    method: 'GET',
    options: { params: { client_id: clientId, days } },
  });
}

export function fetchGeoAuditsLatest(clientId = null) {
  const params = clientId ? { client_id: clientId } : {};
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/geo-audits/latest/',
    method: 'GET',
    options: { params },
  });
}

export function fetchGeoAuditHistory(clientId, days = 30) {
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/geo-audits/',
    method: 'GET',
    options: { params: { client_id: clientId, days } },
  });
}

export function triggerGeoAudit(clientId = null) {
  const payload = clientId ? { client_id: clientId } : {};
  return defaultClient.request({
    url: 'dashboard/facebook/budget-optimizer/geo-audits/trigger/',
    method: 'POST',
    payload,
  });
}
